__turbopack_context__.v({
  "appointment": "scheduleDemoFormSuccess-module-scss-module__jHQ4FG__appointment",
  "appointmentContainer": "scheduleDemoFormSuccess-module-scss-module__jHQ4FG__appointmentContainer",
  "appointmentDate": "scheduleDemoFormSuccess-module-scss-module__jHQ4FG__appointmentDate",
  "appointmentTitle": "scheduleDemoFormSuccess-module-scss-module__jHQ4FG__appointmentTitle",
  "contactDetails": "scheduleDemoFormSuccess-module-scss-module__jHQ4FG__contactDetails",
  "description": "scheduleDemoFormSuccess-module-scss-module__jHQ4FG__description",
  "divider": "scheduleDemoFormSuccess-module-scss-module__jHQ4FG__divider",
  "successContainer": "scheduleDemoFormSuccess-module-scss-module__jHQ4FG__successContainer",
  "title": "scheduleDemoFormSuccess-module-scss-module__jHQ4FG__title",
});
